var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('footer',{staticClass:"footer-distributed",style:({
      position: this.$route.name === 'guard' ? 'fixed' : '',
      height: this.$route.name === 'guard' ? '35px' : '',
    })},[_c('div',{staticClass:"footer-center"},[_c('a',{staticClass:"footer-link",attrs:{"href":_vm.url}},[_c('span',{staticStyle:{"font-weight":"400"}},[_vm._v(_vm._s(_vm.footerText))]),_c('span',{staticClass:"footer-logo",style:({
            background:
              'url(' + _vm.image + ') no-repeat center center / contain',
            'background-size': 'contain',
          })})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }